export default "__VITE_ASSET__d9cd8c8f__"